import React from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useManufacturerQuery from '../hooks/useManufacturerQuery';
import ManufacturerForm from '../components/ManufacturerForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface ManufacturerParams {
  readonly id?: string;
}

const ManufacturerPage: React.FC = () => {
  const { id } = useParams() as ManufacturerParams;
  const manufacturerQuery = useManufacturerQuery(id);
  const manufacturer = manufacturerQuery.data?.getManufacturer?.data;

  const manufacturerName = manufacturer?.name;
  const title = getFormTitle(id, manufacturerName, 'Manufacturer');

  return (
    <SubPage title={title} isLoading={manufacturerQuery.loading} showGoBackButton type="form">
      {<ManufacturerForm title={title} manufacturer={manufacturer || {}} />}
    </SubPage>
  );
};

export default React.memo(ManufacturerPage);
